import {
    AttachmentVm,
    ProjectDetailVm,
    EmployeeDetailVm,
    DocumentDetailVm,
    ProjectHodogramVm,
    ToolDetailVm,
} from '../../../utils/api';
import AttachmentForm from './AttachmentForm';

interface OwnProps {
    attachment?: AttachmentVm;
    project?: ProjectDetailVm;
    employee?: EmployeeDetailVm;
    document?: DocumentDetailVm;
    hodogram?: ProjectHodogramVm;
    tool?: ToolDetailVm;
    onClose: () => void;
    onSuccess: (result: AttachmentVm) => void;
}

export type Props = OwnProps;

export default AttachmentForm;
